import React, { useState } from 'react';
import Select from "./select";
import MovieCard from './MovieCard';
import MovieDetailsModal from './MovieDetailsModal';
import { CITY_OPTIONS } from '../constants';

const MobileMovieSchedule = ({
                                 selectedDate,
                                 selectedCity,
                                 selectedTimePeriod,
                                 layoutMode,
                                 showSections,
                                 futureMovies,
                                 newReleaseMovies,
                                 topRatedMovies,
                                 classicMovies,
                                 remainingMovies,
                                 dateOptions,
                                 timePeriodOptions,
                                 handleDateChange,
                                 handleCityChange,
                                 handleTimePeriodChange,
                                 toggleLayout,
                                 toggleSections,
                                 scrollLeft,
                                 scrollRight,
                                 topRatedScrollRef,
                                 scrollClassicLeft,
                                 scrollClassicRight,
                                 classicScrollRef,
                                 showTooltip,
                                 hideTooltip,
                                 tooltip,
                                 onMovieClick,       // ✅ new
                                 onBookingClick,     // ✅ new
                                 onShareClick        // ✅ new
                             }) => {
    const [selectedMovie, setSelectedMovie] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleCardClick = (movie, event) => {
        event.preventDefault();
        event.stopPropagation();

        onMovieClick(movie);   // ✅ call parent

        setSelectedMovie(movie);
        setIsModalOpen(true);
    };

    const handleModalClose = () => {
        setIsModalOpen(false);
        setSelectedMovie(null);
    };

    return (
        <>
            {/* Selectors */}
            <div className="selector-row mobile-selector">
                <div className="date-selector">
                    <Select
                        defaultOption={CITY_OPTIONS.find(city => city.value === selectedCity) || CITY_OPTIONS[0]}
                        options={CITY_OPTIONS}
                        onOptionChange={handleCityChange}
                        className="date-options"
                    />
                </div>
                <div className="date-selector">
                    <label htmlFor="date-select" className="date-label"></label>
                    <Select
                        defaultOption={dateOptions.find(date => date.value === selectedDate) || dateOptions[0]}
                        options={dateOptions}
                        onOptionChange={handleDateChange}
                        className="date-options"
                    />
                </div>
                <div className="date-selector">
                    <Select
                        defaultOption={timePeriodOptions.find(time => time.value === selectedTimePeriod) || timePeriodOptions[0]}
                        options={timePeriodOptions}
                        onOptionChange={handleTimePeriodChange}
                        className="date-options"
                    />
                </div>
            </div>

            {/* Controls */}
            <div className="selector-row mobile-controls-row">
                <div className="mobile-controls">
                    <div className="layout-controls">
                        <button
                            className={`layout-toggle ${layoutMode === 'grid' ? 'active' : ''}`}
                            onClick={toggleLayout}
                            title={layoutMode === 'grid' ? "Switch to List View" : "Switch to Grid View"}
                        >
                            {layoutMode === 'grid' ? (
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M3 3h4v4H3V3zm6 0h4v4H9V3zm6 0h4v4h-4V3zM3 9h4v4H3V9zm6 0h4v4H9V9zm6 0h4v4h-4V9zM3 15h4v4H3v-4zm6 0h4v4H9v-4zm6 0h4v4h-4v-4z"/>
                                </svg>
                            ) : (
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                    <path d="M3 4h2v2H3V4zm4 0h14v2H7V4zM3 9h2v2H3V9zm4 0h14v2H7V9zm-4 5h2v2H3v-2zm4 0h14v2H7v-2zm-4 5h2v2H3v-2zm4 0h14v2H7v-2z"/>
                                </svg>
                            )}
                        </button>
                    </div>

                    <button
                        className="sections-toggle-button"
                        onClick={toggleSections}
                        title={showSections ? "Hide Sections" : "Show Sections"}
                    >
                        {showSections ? (
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M3 4h2v2H3V4zm4 0h14v2H7V4zM3 9h2v2H3V9zm4 0h14v2H7V9zm-4 5h2v2H3v-2zm4 0h14v2H7v-2zm-4 5h2v2H3v-2zm4 0h14v2H7v-2z"/>
                            </svg>
                        ) : (
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M3 3h4v4H3V3zm6 0h4v4H9V3zm6 0h4v4h-4V3zM3 9h4v4H3V9zm6 0h4v4H9V9zm6 0h4v4h-4V9zM3 15h4v4H3v-4zm6 0h4v4H9v-4zm6 0h4v4h-4v-4z"/>
                            </svg>
                        )}
                    </button>
                </div>
            </div>
            {/* Grid layout */}
            {layoutMode === 'grid' && (
                <>
                    {showSections && newReleaseMovies.length > 0 && (
                        <>
                            <div className="selector-row" data-section="new-releases">
                                <div className="date-selector">New Releases</div>
                            </div>
                            <div className="top-rated-grid-container">
                                <div className="top-rated-grid grid-layout mobile-grid">
                                    {newReleaseMovies.map((movie) => (
                                        <div key={movie.id} onClick={(event) => handleCardClick(movie, event)}>
                                            <MovieCard
                                                movie={movie}
                                                handleMouseEnter={showTooltip}
                                                handleMouseLeave={hideTooltip}
                                                className="mobile-movie-card top-rated-card"
                                            />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </>
                    )}

                    {showSections && topRatedMovies.length > 0 && (
                        <>
                            <div className="selector-row" data-section="top-rated">
                                <div className="date-selector">⭐ Top Rated</div>
                            </div>
                            <div className="top-rated-grid-container">
                                <div className="top-rated-grid grid-layout mobile-grid">
                                    {topRatedMovies.map((movie) => (
                                        <div key={movie.id} onClick={(event) => handleCardClick(movie, event)}>
                                            <MovieCard
                                                movie={movie}
                                                handleMouseEnter={showTooltip}
                                                handleMouseLeave={hideTooltip}
                                                className="mobile-movie-card top-rated-card"
                                            />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </>
                    )}

                    {showSections && classicMovies.length > 0 && (
                        <>
                            <div className="selector-row" data-section="classic">
                                <div className="date-selector">🎬 Classic</div>
                            </div>
                            <div className="classic-grid-container">
                                <div className="classic-grid grid-layout mobile-grid">
                                    {classicMovies.map((movie) => (
                                        <div key={movie.id} onClick={(event) => handleCardClick(movie, event)}>
                                            <MovieCard
                                                movie={movie}
                                                handleMouseEnter={showTooltip}
                                                handleMouseLeave={hideTooltip}
                                                className="mobile-movie-card classic-card"
                                            />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </>
                    )}

                    {showSections && (
                        <>
                            <div className="selector-row" data-section="all-movies">
                                <div className="date-selector">All Movies</div>
                            </div>
                            <div className="unique-all-movies-grid-container">
                                <div className="unique-all-movies-grid grid-layout mobile-grid">
                                    {futureMovies.map((movie) => (
                                        <div key={movie.id} onClick={(event) => handleCardClick(movie, event)}>
                                            <MovieCard
                                                movie={movie}
                                                handleMouseEnter={showTooltip}
                                                handleMouseLeave={hideTooltip}
                                                className="mobile-movie-card all-movies-card"
                                            />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </>
                    )}

                    {!showSections && (
                        <div className="all-movies-grid-container">
                            <div className="all-movies-grid grid-layout mobile-grid">
                                {futureMovies.map((movie) => (
                                    <div key={movie.id} onClick={(event) => handleCardClick(movie, event)}>
                                        <MovieCard
                                            movie={movie}
                                            handleMouseEnter={showTooltip}
                                            handleMouseLeave={hideTooltip}
                                            className="mobile-movie-card all-movies-card"
                                        />
                                    </div>
                                ))}
                            </div>
                        </div>
                    )}
                </>
            )}

            {/* List layout */}
            {layoutMode === 'list' && (
                <div className="movie-schedule list-layout mobile-list">
                    {futureMovies.map((movie) => (
                        <div key={movie.id} onClick={(event) => handleCardClick(movie, event)}>
                            <MovieCard
                                movie={movie}
                                handleMouseEnter={showTooltip}
                                handleMouseLeave={hideTooltip}
                                className="mobile-movie-card"
                            />
                        </div>
                    ))}
                </div>
            )}

            {/* Tooltip */}
            {tooltip.visible && (
                <div className="tooltip mobile-tooltip" style={{ top: tooltip.top, left: tooltip.left }}>
                    {tooltip.text}
                </div>
            )}

            {/* Modal */}
            <MovieDetailsModal
                movie={selectedMovie}
                isOpen={isModalOpen}
                onClose={handleModalClose}
                onBookingClick={onBookingClick}    // ✅ pass
                onShareClick={onShareClick}        // ✅ pass
            />
        </>
    );
};

export default MobileMovieSchedule;
